function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "D072D985-A48B-4A25-BFE9-8BE432126E86@2x");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M15.9393398,10.4393398 C16.5251263,9.85355339 17.4748737,9.85355339 18.0606602,10.4393398 C18.6464466,11.0251263 18.6464466,11.9748737 18.0606602,12.5606602 L14.0606602,16.5606602 C13.4748737,17.1464466 12.5251263,17.1464466 11.9393398,16.5606602 L7.93933983,12.5606602 C7.35355339,11.9748737 7.35355339,11.0251263 7.93933983,10.4393398 C8.52512627,9.85355339 9.47487373,9.85355339 10.0606602,10.4393398 L13,13.3786797 L15.9393398,10.4393398 Z",
  id: "path-1"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Asset-Artboard-Page",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons/Dropdown"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2-dropdown",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Shape",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u21B3-\\uD83C\\uDFA8Color-Colors/Black",
  mask: "url(#mask-2-dropdown)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Color",
  x: 0,
  y: 0,
  width: 25.390625,
  height: 20.921875
}))));

var SvgDropdown = function SvgDropdown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDropdown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Dropdown.ff49cb18.svg";
export { ForwardRef as ReactComponent };